/* eslint-disable */
/**
 * Checks if the device is an iOS device or not.
 * @returns {boolean} true if device is iOS, otherwise false.
 */
const isIOS = () => navigator && /iPad|iPhone|iPod/.test(navigator.platform);

export const isSafari = () => navigator.userAgent.toLowerCase().indexOf('safari') != -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1
// for IOS we looking for CriOS rather as this is the only difference with safari
&& navigator.userAgent.toLowerCase().indexOf('crios') === -1;

export const isStandalone = () => window.navigator.standalone;

export default isIOS;
